import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const triggerBrowserDownload = (downloadUrl, programName) => {
  const normalizedUrl = new URL(String(downloadUrl).trim(), window.location.origin).toString();
  const link = document.createElement('a');
  link.href = normalizedUrl;
  link.download = `${String(programName || 'program-documents').trim() || 'program-documents'}.zip`;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadProgramDocuments = async ({ programId, programName }) => {
  if (!programId) {
    throw new Error('A program must be selected before downloading documents.');
  }

  const createProgramDocumentsZip = httpsCallable(functions, 'createProgramDocumentsZip', {
    timeout: 540000
  });
  const result = await createProgramDocumentsZip({
    programId,
    programName: programName || ''
  });

  const payload = result?.data || {};

  if (!payload?.downloadUrl) {
    throw new Error('The zip export did not return a download URL.');
  }

  triggerBrowserDownload(payload.downloadUrl, programName);
  return payload;
};
